@for (alert of alertService.stickyAlerts; track alert) {
<div class="alert" [class]="getAlertClass(alert.type)" role="alert">
  <span>{{ alert.message }}</span>
  <button type="button" class="btn-close crd-alert-close" data-bs-dismiss="alert" aria-label="Close" (click)="alertService.closeSticky(alert)"></button>
</div>
}
<div class="alert-floats" aria-live="polite" aria-atomic="true">
  @for (alert of alertService.selfClosingAlerts; track alert) {
  <div class="alert crd-floating-alert" [class]="getAlertClass(alert.type)" role="alert">
    <span class="crd-floating-alert__message">{{ alert.message }}</span>
    <button type="button" class="btn-close crd-alert-close" data-bs-dismiss="alert" aria-label="Close" (click)="alertService.closeSelfClosing(alert)"></button>
  </div>
  }
</div>
